import React from "react";
import PropTypes from "prop-types";
import styles from "./SelectNumberInput.module.css";

/**
 * Interactive component. A select input for numbers.
 */
export function SelectNumberInput({
  labelText,
  labelImg,
  numberOptions,
  onSelect,
  value,
}) {
  return (
    <div className={styles.container}>
      {(labelText || labelImg) && (
        <span className={styles.label}>
          {labelImg}
          {labelText}
        </span>
      )}
      {/* <select className={styles.select} onChange={onSelect}>
        {numberOptions.map((option) => (
          <option value={option} selected={option === value}>
            {option}
          </option>
        ))}
      </select> */}
      <select className={styles.select} onChange={onSelect} value={value}>
        {numberOptions.map((option) => (
          <option value={option} key={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}

SelectNumberInput.propTypes = {
  /**
   * Optional string for the label text.
   */
  labelText: PropTypes.string,
  /**
   * Optional element for a label image or icon.
   */
  labelImg: PropTypes.element,
  /**
   * An array containing the select options.
   */
  numberOptions: PropTypes.arrayOf(PropTypes.string),
  /**
   * Function that fires when an option is selected.
   */
  onSelect: PropTypes.func,
  /**
   * The selected value.
   */
  value: PropTypes.string,
};
